import { ApplicationsAPI } from "api/api/applicationsApi/applicationsApi";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  GetApplicationsMarathonIndividualIssuanceParams,
  GetApplicationsMarathonIndividualIssuanceResponse,
} from "api/api/applicationsApi/types";

export const getApplicationsMarathonIndividualIssuance = createAsyncThunk<
  GetApplicationsMarathonIndividualIssuanceResponse,
  GetApplicationsMarathonIndividualIssuanceParams
>(
  "applications/getApplicationsMarathonIndividualIssuance",
  async ({ marathonId, ...params }, { rejectWithValue }) => {
    try {
      const data =
        await ApplicationsAPI.getApplicationsMarathonIndividualIssuance({
          marathonId,
          ...params,
        });
      return data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error(
          "Error while getting applications marathon individual issuance",
          error.response?.data
        );
        return rejectWithValue(error.response?.data || "Unknown error");
      } else {
        console.error(
          "Error while getting applications marathon individual issuance",
          error
        );
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  }
);
